/**
 * Preferencia explícita (localStorage) y lectura de cookies del Worker.
 * Orden completo de detección: src/lib/languagePolicy.ts + src/i18n/config.ts.
 */

import { BRAND_STORAGE_PREFIX } from "./brandConfig";

export const I18N_USER_CHOICE_KEY = `${BRAND_STORAGE_PREFIX}_i18n_user_choice`;

export function markI18nUserLanguageChoice(): void {
  try {
    localStorage.setItem(I18N_USER_CHOICE_KEY, "1");
  } catch {
    /* ignore */
  }
}

export function hasI18nUserLanguageChoice(): boolean {
  try {
    return localStorage.getItem(I18N_USER_CHOICE_KEY) === "1";
  } catch {
    return false;
  }
}

function readCookie(name: string): string | null {
  if (typeof document === "undefined") return null;
  const parts = document.cookie.split(";");
  for (const part of parts) {
    const idx = part.indexOf("=");
    if (idx === -1) continue;
    const key = part.slice(0, idx).trim();
    const rawValue = part.slice(idx + 1).trim();
    if (key === name) {
      try {
        return decodeURIComponent(rawValue);
      } catch {
        return rawValue;
      }
    }
  }
  return null;
}

/** País ISO2 desde cookie del Worker (si existe). */
export function readEdgeCountryCookie(): string | null {
  if (typeof document === "undefined") return null;
  const parts = document.cookie.split(";");
  for (const part of parts) {
    const idx = part.indexOf("=");
    if (idx === -1) continue;
    const key = part.slice(0, idx).trim();
    if (key !== "user_country") continue;
    const rawValue = part.slice(idx + 1).trim();
    try {
      return decodeURIComponent(rawValue).toUpperCase().slice(0, 2) || null;
    } catch {
      return rawValue.toUpperCase().slice(0, 2) || null;
    }
  }
  return null;
}

/** Idioma que inyecta el Worker (cookie) o el script de plantilla. */
export function readEdgeLanguageRaw(): string | null {
  const fromCookie = readCookie("user_language")?.trim();
  if (fromCookie) return fromCookie;
  if (typeof window === "undefined") return null;
  const cfg = (
    window as unknown as { __TEMPLATE_CONFIG__?: { language?: string } }
  ).__TEMPLATE_CONFIG__;
  return cfg?.language?.trim() || null;
}
